<template>
  <div class="card card-info mt-3" v-if="game">
    <div class="card-body p-3">
      <ul class="nav nav-tabs row">
        <li class="nav-item col text-center" v-for="tab in ['Chat', 'Notes']" v-bind:key="tab">
          <a class="nav-link" :class="{'active': tab === currentTab }" href="#" @click.prevent="setCurrentTab(tab)"><strong>{{ tab }}</strong></a>
        </li>
      </ul>
      <div v-if="currentTab === 'Chat'">
        <Chat :room-id="$route.params.game_id" :can-send-message="canSendMessage" class="mt-2" :send-message-placeholder="'Be nice in the chat'"></Chat>
      </div>
      <div v-if="currentTab === 'Notes'">
        <textarea class="textarea--notes" name="" id="" cols="30" rows="11" placeholder="Type your private notes here" v-model="notes"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import jQuery from 'jquery';
import Chat from '@/components/Chat.vue';

const $ = jQuery;

export default {
  name: 'ChatAndNotes',
  props: ['game'],
  components: {
    Chat,
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'getCurrentUser', 'getUserData']),
  },
  methods: {
    canSendMessage() {
      let res = false;
      for (let i = 0; i < this.game.players.length; i += 1) {
        const player = this.game.players[i];
        if (this.getCurrentUser.uid === player.uid) {
          res = true;
        }
      }
      return res;
    },
    setCurrentTab(tab) {
      this.currentTab = tab;
      Vue.localStorage.set('chatOrNoteTab', tab);
      setTimeout(() => {
        const $elem = $('#chat-room');
        if ($elem.is(':visible')) {
          $elem.animate({ scrollTop: $elem[0].scrollHeight + 10000 }, 400);
        }
      }, 0);
    },
  },
  data() {
    return {
      currentTab: (Vue.localStorage.get('chatOrNoteTab')) ? Vue.localStorage.get('chatOrNoteTab') : 'Chat',
      notes: '',
    };
  },
};
</script>

<style lang="scss" scoped>
.textarea--notes {
  padding: 10px;
  width: 100%;
  border: none;
  outline: none;
  min-height: 250px;
}
</style>
